<div class="software-item card d-none d-md-grid">
  @if (software.iconUrl) {
    <div class="software-item-icon-wrapper">
      <a
        class="software-item-icon-container d-inline-block"
        [routerLink]="['/software', software.id]"
      >
        <img [ngSrc]="software.iconUrl" [alt]="software.name" fill />
      </a>
    </div>
  }
  @if (!software.iconUrl) {
    <div class="software-item-icon-placeholder">
      <a
        class="software-item-icon-container d-inline-block"
        [routerLink]="['/software', software.id]"
      >
        <span class="material-symbols-outlined me-1">deployed_code</span>
      </a>
    </div>
  }
  <div class="d-flex align-items-center">
    <h2 class="mb-0 me-3">
      <a [routerLink]="['/software', software.id]"
        >{{ software.name }}
        @if (software.artifacts?.[0]?.version) {
          <span class="software-item-version"
            >: {{ software.artifacts![0].version }}</span
          >
        }
      </a>
    </h2>
    <div class="software-item-label-wrapper d-flex flex-row align-items-center">
      @if (software.platform) {
        <span class="badge platform-label me-2">{{
          software.platform.name
        }}</span>
      }
      @if (software.type) {
        <span class="badge type-label me-2">{{ software.type.name }}</span>
      }
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-end flex-grow-1">
    @if (software.artifacts?.length) {
      <app-software-artifact-download-button
        class="me-2"
        [artifact]="software.artifacts![0]"
      ></app-software-artifact-download-button>
    }
  </div>
  <div class="d-inline-flex flex-column">
    @if (software.description) {
      <markdown [data]="software.description"></markdown>
    }
    @if (latestArtifact) {
      @if (showDetails) {
        <b
          ><i class="text-addition">{{
            'software.latestVersion' | translate
          }}</i></b
        >
      }
      @if (latestArtifact.buildNumber) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.buildNumber' | translate }}</b
          >: {{ latestArtifact.buildNumber }}</span
        >
      }
      @if (isAdmin && latestArtifact.branchName) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.branchName' | translate }}</b
          >: {{ latestArtifact.branchName }}</span
        >
      }
      @if (isAdmin && latestArtifact.creationDate) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.creationDate' | translate }}</b
          >: {{ latestArtifact.creationDate | dateTime }}</span
        >
      }
      @if (
        latestArtifact.releaseDate &&
        latestArtifact.status === SoftwareArtifactStatus.RELEASED
      ) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.releaseDate' | translate }}</b
          >: {{ latestArtifact.releaseDate | dateTime }}</span
        >
      }
    }
  </div>
  <div></div>
  <div
    class="software-item-buttons d-flex flex-row align-items-center align-self-start"
  >
    <a class="me-2" [routerLink]="['/software', software.id]">{{
      'details' | translate
    }}</a>
    @if (isAdmin) {
      <button class="btn btn-link me-2 p-0" (click)="edit.emit()">
        {{ 'edit' | translate }}
      </button>
    }
  </div>
  <div></div>
</div>
<div class="software-item-sm card d-sm-flex d-md-none flex-column">
  <h2 class="mb-0 me-3">
    <a [routerLink]="['/software', software.id]"
      >{{ software.name }}
      @if (software.artifacts?.[0]?.version) {
        <span class="software-item-version"
          >: {{ software.artifacts![0].version }}</span
        >
      }
    </a>
  </h2>
  <div class="d-flex align-items-center justify-content-between flex-grow-1">
    <div class="software-item-label-wrapper d-flex flex-row align-items-center">
      @if (software.platform) {
        <span class="badge platform-label me-2">{{
          software.platform.name
        }}</span>
      }
      @if (software.type) {
        <span class="badge type-label me-2">{{ software.type.name }}</span>
      }
    </div>
    @if (software.artifacts?.length) {
      <app-software-artifact-download-button
        class="me-2"
        [artifact]="software.artifacts![0]"
      ></app-software-artifact-download-button>
    }
  </div>
  <div class="d-inline-flex flex-column">
    @if (software.description) {
      <markdown [data]="software.description"></markdown>
    }
    @if (latestArtifact) {
      @if (showDetails) {
        <b
          ><i class="text-addition">{{
            'software.latestVersion' | translate
          }}</i></b
        >
      }
      @if (latestArtifact.buildNumber) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.buildNumber' | translate }}</b
          >:<br />{{ latestArtifact.buildNumber }}</span
        >
      }
      @if (isAdmin && latestArtifact.branchName) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.branchName' | translate }}</b
          >:<br />{{ latestArtifact.branchName }}</span
        >
      }
      @if (isAdmin && latestArtifact.creationDate) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.creationDate' | translate }}</b
          >:<br />{{ latestArtifact.creationDate | dateTime }}</span
        >
      }
      @if (
        latestArtifact.releaseDate &&
        latestArtifact.status === SoftwareArtifactStatus.RELEASED
      ) {
        <span class="text-addition"
          ><b>{{ 'software.artifact.releaseDate' | translate }}</b
          >:<br />{{ latestArtifact.releaseDate | dateTime }}</span
        >
      }
    }
  </div>
  <div></div>
  <div
    class="software-item-buttons d-flex flex-row align-items-center align-self-start"
  >
    <a class="me-2" [routerLink]="['/software', software.id]">{{
      'details' | translate
    }}</a>
    @if (isAdmin) {
      <button class="btn btn-link me-2 p-0" (click)="edit.emit()">
        {{ 'edit' | translate }}
      </button>
    }
  </div>
  <div></div>
</div>
